import clsx from 'clsx';
import { referralsFolder } from 'constants/Referrals';
import styles from './AvatarOnRubberRing.module.css';
import { AvatarWithAccessory } from './AvatarWithAccessory';

type RubberRingColor = 'blue' | 'red';

const ringAssetByColor: Record<RubberRingColor, string> = {
  blue: 'rubber-ring-blue.svg',
  red: 'rubber-ring-red.svg',
};

interface AvatarOnRubberRingProps {
  avatarUrl?: string;
  color?: RubberRingColor;
}

export const AvatarOnRubberRing = ({
  avatarUrl,
  color = 'blue',
}: AvatarOnRubberRingProps) => {
  return (
    <AvatarWithAccessory
      avatarUrl={avatarUrl}
      accessorySrc={`${referralsFolder}/${ringAssetByColor[color]}`}
      accessoryClassName={clsx(styles.ringAccessory)}
      relaxing
    />
  );
};
